<ng-template #loading_heritage>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>

<compass-heritage-form *ngIf="heritagePois$ | async as heritagePois;
          else loading_heritage" [heritagePois]="heritagePois" style="width: 100%">
</compass-heritage-form>